import { a125, a128, a131, a134, a137, a140, a163, a194, a226, a248 } from "Components/Api/RootApiPath";


export const fetchAllMasterData = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
//   try {
//     const data = await fetch(a188, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         ClientCode: clientCode,
//       }),
//     });
//     console.log(data);
//     if (!data.ok) {
//       throw new Error(
//         `${response.statusText || "Failed to fetch invoice list"}`
//       );
//     }
//     return data?.json();

//     return data;
//   } catch (e) {
//     throw error;
//   }



  try {
    const [
      allSku,
      categories,
      productTypes,
      designs,
      purities,
      diamondAttributes,
      stoneAttributes,
    ] = await Promise.allSettled([
        a163,
        a125,
        a128,
        a131,
        a134,
        a194,
        a248
 
    ],{
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });

    // Check the results of each promise and handle errors if any
    const results = {
      allSku: allSku.status === "fulfilled" ? allSku.value : null,
      categories: categories.status === "fulfilled" ? categories.value : null,
      productTypes:
        productTypes.status === "fulfilled" ? productTypes.value : null,
      designs: designs.status === "fulfilled" ? designs.value : null,
      purities: purities.status === "fulfilled" ? purities.value : null,
      diamondAttributes:
        diamondAttributes.status === "fulfilled"
          ? diamondAttributes.value
          : null,
      stoneAttributes:
        stoneAttributes.status === "fulfilled" ? stoneAttributes.value : null,
    };

    // Log and handle any rejected promises (optional)
    const failedPromises = [
      allSku,
      categories,
      productTypes,
      designs,
      purities,
      diamondAttributes,
      stoneAttributes,
    ].filter((result) => result.status === "rejected");

    if (failedPromises.length > 0) {
      failedPromises.forEach((failedPromise) => {
        console.error(`Failed to fetch data: ${failedPromise.reason}`);
      });
    }

    return results;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw new Error(`Failed to fetch dropdown list data: ${error.message}`);
  }
};

export const fetchAllCollection = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a140, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch collection list"}`
      );
    }
    const res = await data?.json();
    return res;
  } catch (e) {
    console.log(e.message);
    throw new Error(`${"Failed to fetch collection list, try again later"}`);
  }
};

export const fetchAllPackets = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a226, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch collection list"}`
      );
    }
    const res = await data?.json();
    return res;
  } catch (e) {
    console.log(e.message);
    throw new Error(`${"Failed to fetch collection list, try again later"}`);
  }
};


export const fetchAllBoxes = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a137, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch box list"}`
      );
    }
    const res = await data?.json();
    return res;
  } catch (e) {
    console.log(e.message);
    throw new Error(`${"Failed to fetch box list, try again later"}`);
  }
};


